import { Eye, EyeOff } from 'lucide-react'
import { useState, forwardRef, ComponentProps } from 'react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

import { cn } from '@/lib/utils'

const PasswordInput = forwardRef<
  HTMLInputElement,
  Omit<ComponentProps<'input'> & { containerClassName?: string }, 'type'>
>(({ className, containerClassName, ...props }, ref) => {
  const [isReadablePassword, setIsReadablePassword] = useState(false)
  return (
    <div className={cn('relative', containerClassName)}>
      <Input {...props} type={isReadablePassword ? 'text' : 'password'} className={cn('pe-12', className)} ref={ref} />
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="absolute end-2 top-1/2 size-6 -translate-y-1/2 bg-transparent text-muted-foreground"
        onClick={() => setIsReadablePassword(!isReadablePassword)}
      >
        {isReadablePassword ? <Eye className="size-5" /> : <EyeOff className="size-5" />}
      </Button>
    </div>
  )
})
PasswordInput.displayName = 'PasswordInput'

export { PasswordInput }
